import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { createDistributor } from 'app-support/licenses/state/actions'
import { enumToOptions } from '@cbgms/base/utils/helpers'
import { LicenseType } from '@carsys/enums/license-type'
import { isRequired } from '@cbgms/base/utils/validations'
import OptionalLicenseFields from '../components/OptionalLicenseFields'
import { TLicenseTypeValues } from '@cbgms/api'
import { useNotifier } from '@cbgms/base/notifier'
import { useHistory } from 'react-router-dom'
import FormikFormLayout from 'core/page/layout/FormikFormLayout'
import { Form } from '@carsys/form'
import { Dropdown } from '@carsys/form/src/Dropdown'
import { TextField } from '@carsys/form/src/TextField'
import Box from '@mui/material/Box'

interface IFormValues {
  Name: string
  LicenseType: TLicenseTypeValues
  [key: string]: any
}

const emptyInitialForm = {
  Name: '',
  LicenseType: LicenseType.HaynesPro,
  HaynesPro: {
    DistributorID: '',
    DistributorClientPostfix: '',
    DistributorPassword: '',
    CompanyIdentification: ''
  }
}

const AddDistributor = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const notifier = useNotifier()
  const history = useHistory()

  const options = enumToOptions(LicenseType, 'EnumLicenseType')

  const handleSubmit = async (values: IFormValues) => {
    try {
      const { Data } = await dispatch(createDistributor(values))
      return { ...values, UUID: Data.UUID }
    } catch (e) {
      throw e
    }
  }

  const onSubmitSuccess = (values: IFormValues) => {
    notifier.success(t('Distributor.SuccessfullyUpdated'))
    history.push(`/licenses/distributors/edit/${values.UUID}`)
  }

  return (
    <Form<IFormValues, IFormValues> initialValues={emptyInitialForm} onSubmit={handleSubmit} onSubmitSuccess={onSubmitSuccess}>
      {formikBag => {
        return (
          <FormikFormLayout backButtonProps={{ to: '/licenses/distributors' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Box sx={{ maxWidth: 300 }}>
                <TextField validate={isRequired} required name='Name' data-testid='input-name' label={t('distributor.name')} />
              </Box>
              <Box sx={{ maxWidth: 300 }}>
                <Dropdown
                  data-testid='dropdown-licensetype'
                  validate={isRequired}
                  required
                  label={t('distributor.licensetype')}
                  name='LicenseType'
                  options={options}
                />
              </Box>
              <Box>{formikBag.values.LicenseType && <OptionalLicenseFields licenseType={formikBag.values.LicenseType} />}</Box>
            </Box>
          </FormikFormLayout>
        )
      }}
    </Form>
  )
}

export default AddDistributor
